/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import DataTable from "components/organisms/DataTable/DataTable";
import { getLocationApprovalLevels } from "api";
import Button from "components/atoms/Button/Button";
import useTableRequest from "hooks/useTableRequest";
import GlobalTableSearch from "components/organisms/DataTable/components/GlobalTableSearch";
import { useNavigate } from "react-router-dom";
import getLabel from "helpers/getLabel";
import usePermissions from "hooks/usePermissions";
import NewApprovalDialog from "./NewApprovalDialog";

function LocationLevel() {
  const intl = useIntl();
  const [levelId, setLevelId] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const navigate = useNavigate();
  const { permissions } = usePermissions();
  const adminSettings = JSON.parse(permissions || "{}")?.permissions?.admin_settings;
  const viewOnly = Boolean(!adminSettings?.edit_approval_levels);

  const columns = [
    {
      Header: getLabel("Payment location"),
      accessor: "name",
      sortable: true,
      Cell: ({ value }) => <p className="pl-9 pt-8 pb-8 mb-0 mr-1 font-weight-bold">{value}</p>,
    },
    {
      Header: intl.formatMessage({ id: "settings.approval-level.tableLevelHeader", defaultMessage: "Level" }),
      accessor: "approval_level_count",
      sortable: true,
      Cell: ({ value }) => <p className="pl-9 pt-8 pb-8 mb-0 mr-1">{value}</p>,
    },
    {
      Header: intl.formatMessage({ id: "settings.approval-level.tableMembersHeader", defaultMessage: "Members" }),
      accessor: "member_count",
      sortable: true,
      Cell: ({ value }) => <p className="pl-9 pt-8 pb-8 mb-0 mr-1">{value}</p>,
    },
  ];

  const { instance, fetching, totalData, refetch } = useTableRequest(getLocationApprovalLevels, columns, {
    filters: (globalFilter) => ({
      ...(globalFilter.query?.length && { query: globalFilter.query }),
      ...(globalFilter.payment_location?.length && { payment_location: globalFilter.payment_location }),
    }),
    deps: [location],
  });

  const handleCloseDialog = () => {
    setLevelId(null);
    setShowDialog(false);
  };

  return (
    <div style={{ marginTop: "16px" }}>
      <NewApprovalDialog
        totalOrders={instance?.data?.length ? instance?.data?.length : 1}
        refetch={refetch}
        id={levelId}
        close={handleCloseDialog}
        isOpen={showDialog}
        isLocation
        viewOnly={viewOnly}
      />
      <DataTable
        tableInstance={instance}
        totalData={totalData}
        isLoading={fetching}
        draggable={false}
        onRowClick={(row) => {
          navigate(`/settings/approval-levels/${row.original.reference_number}`, {
            state: { name: row.original.name },
          });
        }}
        headerLeft={
          <div className="d-md-flex justify-content-between align-items-center flex-md-row flex-column w-100">
            <div className="font-weight-bold d-flex" style={{ fontSize: "24px", marginBottom: "16px", marginTop: "8px" }}>
              <FormattedMessage id="settings.approval-level.locationLevel" defaultMessage="Location level" />
              <div className="w-30-px ml-3 mt-1">
                <GlobalTableSearch
                  currentFilters={instance.state.globalFilter}
                  setFilters={instance.setGlobalFilter}
                  filterKey="query"
                  eventContext="Address Book"
                />
              </div>
            </div>

            {!viewOnly && (
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    setLevelId(null);
                    setShowDialog(true);
                  }}
                >
                  <FormattedMessage
                    id="settings.approval-level.newSpecificApprovalLevel"
                    defaultMessage="New specific approval level"
                  />
                </Button>
              </div>
            )}
          </div>
        }
        headerRight={null}
      />
    </div>
  );
}
export default LocationLevel;
